export default "__VITE_ASSET__BFXyHSrs__"